import Dialog from '@/components/Dialog';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from '@/i18n/use-translations';
import { TaskItem } from './TaskItem';

export default function PointsTaskDialog({
  taskListData,
  open,
  onClose,
  deviceType,
}: {
  taskListData: any[];
  open: boolean;
  onClose: () => void;
  deviceType: EPlatform;
}) {
  const t = useTranslations('account.pointsMall.pointsTaskDialog');

  const renderContent = () => {
    return (
      <div className="flex flex-col gap-12">
        {taskListData.map((item) => (
          <TaskItem key={item.title} item={item} variant="dialog" deviceType={deviceType} />
        ))}
      </div>
    );
  };
  return (
    <>
      <WebOnly>
        <Dialog
          open={open}
          onClose={onClose}
          title={t('title.web')}
          maxWidth="lg"
          PaperProps={{ style: { maxHeight: '75vh', minHeight: '460px' } }}
          footer={<div className="pb-[28px]" />}
        >
          {renderContent()}
        </Dialog>
      </WebOnly>
      <WapOnly>
        <Popup
          open={open}
          onClose={onClose}
          title={t('title.mobile')}
          height="85vh"
          position="bottom"
          showDivider={false}
        >
          {renderContent()}
        </Popup>
      </WapOnly>
    </>
  );
}
